/**
 * پیکربندی لایه‌های کلاژ ۳D لندینگ — موقعیت به‌صورت درصد نسبت به stage داخلی (logical start برای RTL/LTR).
 * depth: ضریب پارالاکس ماوس (~۰.۲ تا ۱)
 */

export const COLLAGE_VARIANTS = /** @type {const} */ (['process', 'ideal', 'smb']);

/** @typedef {{ src: string, top: string, start: string, width: string, zIndex: number, depth: number, staggerMs: number, float: 'a' | 'b' | 'none', hideBelowMd?: boolean }} CollageLayer */

/** @type {Record<string, CollageLayer[]>} */
export const COLLAGE_LAYERS_BY_VARIANT = {
  process: [
    {
      src: '/landing/process/design-desk.png',
      top: '6%',
      start: '14%',
      width: '78%',
      zIndex: 4,
      depth: 0.75,
      staggerMs: 90,
      float: 'a',
    },
    {
      src: '/landing/process/growth-chart.png',
      top: '0%',
      start: '0%',
      width: '38%',
      zIndex: 3,
      depth: 0.55,
      staggerMs: 180,
      float: 'a',
    },
    {
      src: '/landing/process/contract.png',
      top: '48%',
      start: '0%',
      width: '46%',
      zIndex: 2,
      depth: 0.45,
      staggerMs: 0,
      float: 'b',
    },
    {
      src: '/landing/process/whiteboard.png',
      top: '34%',
      start: '50%',
      width: '44%',
      zIndex: 1,
      depth: 0.35,
      staggerMs: 260,
      float: 'b',
      hideBelowMd: true,
    },
  ],
  ideal: [
    {
      src: '/landing/ideal/workbench.png',
      top: '38%',
      start: '0%',
      width: '100%',
      zIndex: 1,
      depth: 0.4,
      staggerMs: 0,
      float: 'a',
    },
    {
      src: '/landing/ideal/crane.png',
      top: '14%',
      start: '42%',
      width: '54%',
      zIndex: 3,
      depth: 0.6,
      staggerMs: 190,
      float: 'a',
    },
    {
      src: '/landing/ideal/hard-hat.png',
      top: '0%',
      start: '4%',
      width: '34%',
      zIndex: 4,
      depth: 0.85,
      staggerMs: 100,
      float: 'b',
    },
    {
      src: '/landing/ideal/star-badge.png',
      top: '4%',
      start: '34%',
      width: '24%',
      zIndex: 5,
      depth: 0.95,
      staggerMs: 280,
      float: 'b',
      hideBelowMd: true,
    },
  ],
  smb: [
    {
      src: '/landing/smb/meeting.png',
      top: '8%',
      start: '8%',
      width: '84%',
      zIndex: 3,
      depth: 0.55,
      staggerMs: 190,
      float: 'a',
    },
    {
      src: '/landing/smb/tools-board.png',
      top: '0%',
      start: '46%',
      width: '44%',
      zIndex: 4,
      depth: 0.85,
      staggerMs: 100,
      float: 'b',
    },
    {
      src: '/landing/smb/pallet.png',
      top: '46%',
      start: '0%',
      width: '52%',
      zIndex: 2,
      depth: 0.5,
      staggerMs: 0,
      float: 'a',
    },
    {
      src: '/landing/smb/mallet.png',
      top: '50%',
      start: '54%',
      width: '38%',
      zIndex: 1,
      depth: 0.65,
      staggerMs: 260,
      float: 'b',
      hideBelowMd: true,
    },
  ],
};
